import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "id"]
const _hoisted_2 = ["id", "disabled"]

import { computed, useSlots, PropType } from 'vue';
import NIcon from '../../brand/icon/icon.vue';
import { IconType } from '@shared/designsystem/components/brand/icon/icon.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-button',
},
  __name: 'button',
  props: {
  variant: {
    type: String as PropType<
      | 'primary'
      | 'secondary'
      | 'split'
      | 'success'
      | 'danger'
      | 'ghost'
      | 'action'
      | 'primary--outline'
      | 'secondary--outline'
    >,
  },
  href: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
  },
  icon: {
    type: String as PropType<IconType>,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {



// Define props for the component.
const props = __props;

const emit = __emit;

// Computed property for button class
const buttonClass = computed(() => {
  return {
    'btn--primary': props.variant === 'primary' || props.variant === 'primary--outline',
    'btn--secondary': props.variant === 'secondary' || props.variant === 'secondary--outline',
    'btn--success': props.variant === 'success',
    'button is-info': props.variant === 'split',
    'btn--danger': props.variant === 'danger',
    'btn--action': props.variant === 'action',
    'btn--outline': props.variant === 'primary--outline' || props.variant === 'secondary--outline',
    'btn--ghost': props.variant === 'ghost',
    'btn--loading': props.loading,
    'btn--icon': props.icon,
    'btn--no-text': !hasSlotContent.value,
  };
});

// Computed property to check if the slot is empty
const hasSlotContent = computed(() => {
  return (
    slots.default && slots.default().some((vnode) => vnode.children && vnode.children.toString().trim().length > 0)
  );
});

// Access to the slots
const slots = useSlots();

return (_ctx: any,_cache: any) => {
  return (__props.href)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: __props.href,
        class: _normalizeClass(["btn", buttonClass.value]),
        id: __props.id,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
      }, [
        (__props.icon)
          ? (_openBlock(), _createBlock(NIcon, {
              key: 0,
              icon: __props.icon,
              class: _normalizeClass(["btn__icon", { 'btn__icon--no-text': !hasSlotContent.value }])
            }, null, 8, ["icon", "class"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass(["btn", buttonClass.value]),
        id: __props.id,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('click', $event))),
        disabled: __props.disabled
      }, [
        (__props.icon)
          ? (_openBlock(), _createBlock(NIcon, {
              key: 0,
              icon: __props.icon,
              class: _normalizeClass(["btn__icon", { 'btn__icon--no-text': !hasSlotContent.value }])
            }, null, 8, ["icon", "class"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_2))
}
}

})